module.exports = __webpack_public_path__ + "img/categorie-accesoires-famille-boutrais-big.3e6d557e.jpg";